import { render, staticRenderFns } from "./CardItemLotesPeriodoSelecionado.vue?vue&type=template&id=02c24473&"
import script from "./CardItemLotesPeriodoSelecionado.vue?vue&type=script&lang=js&"
export * from "./CardItemLotesPeriodoSelecionado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports